var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100 d-flex flex-column justify-center align-center"},[_c('div',{staticStyle:{"width":"100px","height":"100px"},attrs:{"id":"loading-animal"}}),_c('h4',{staticStyle:{"color":"#7e58c4","font-family":"maplestory"}},[_vm._v("집에서 나오는중")])])
}]

export { render, staticRenderFns }